import React, { useEffect } from 'react';
import FormControl from '@visa/vds/form-control';
import Input from '@visa/vds/input';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import { DEFAULT_COUNTRY_CODE } from '../../../_constants/GlobalConstants';
import Select from '@visa/vds/select';
import MCSControlInput from 'components/MCSControlInput';

const ManageUserDetails = (props) => {
    useEffect(() => {
        props.clearErrors("email");
        props.setValue("email", props.user.email)
    }, [])

    return (
        <>
            <Row noGutter>
                <Col>
                    <FormControl position="left" space="seventy">
                        <Input
                            label="First Name"
                            name="first-name"
                            value={props.user && props.user.firstName != null ? props.user.firstName : ""}
                            onChange={(e) => props.setUser({ ...props.user, firstName: e.target.value })}
                        />
                    </FormControl>
                </Col>
                <Col>
                    <FormControl position="left" space="seventy">
                        <Input
                            label="Last Name"
                            name="last-name"
                            value={props.user && props.user.lastName != null ? props.user.lastName : ""}
                            onChange={(e) => props.setUser({ ...props.user, lastName: e.target.value })}
                        />
                    </FormControl>
                </Col>
            </Row>
            <Row noGutter>
                <Col>
                    <FormControl position="left" space="seventy">
                        <Input
                            label="Title"
                            name="job-title"
                            value={props.user && props.user.jobTitle != null ? props.user.jobTitle : ""}
                            onChange={(e) => props.setUser({ ...props.user, jobTitle: e.target.value })}
                        />
                    </FormControl>
                </Col>
                <Col>
                    <FormControl position="left" space="seventy">
                        <MCSControlInput
                            control={props.control}
                            label="Email"
                            name="email"
                            value={props.user && props.user.email != null ? props.user.email : ""}
                            handleChange={(e) => props.setUser({ ...props.user, email: props.getValues("email") })}
                        />
                    </FormControl>
                </Col>
            </Row>
            <Row noGutter>
                <Col>
                    <FormControl position="left" space="seventy">
                        <Input
                            label="Phone"
                            name="phone"
                            value={props.user && props.user.phone != null ? props.user.phone : ""}
                            onChange={(e) => props.setUser({ ...props.user, phone: e.target.value })}
                        />
                    </FormControl>
                </Col>
                <Col>
                    <FormControl position="left" space="seventy">
                        <Input
                            label="City"
                            name="city"
                            value={props.user && props.user.city != null ? props.user.city : ""}
                            onChange={(e) => props.setUser({ ...props.user, city: e.target.value })}
                        />
                    </FormControl>
                </Col>
            </Row>
            <Row noGutter>
                <Col>
                    <FormControl position="left" space="seventy">
                        <Input
                            label="State"
                            name="state"
                            value={props.user && props.user.state != null ? props.user.state : ""}
                            onChange={(e) => props.setUser({ ...props.user, state: e.target.value })}
                        />
                    </FormControl>
                </Col>
                <Col>
                    <FormControl>
                        <Select style={{ height: "auto" }} label="Country/Region" fullwidth
                            value={props.user && props.user.countryCode != null ? props.user.countryCode : DEFAULT_COUNTRY_CODE}
                            onChange={(e) => props.setUser({ ...props.user, countryCode: e.target.value })}
                        >
                            {props.countries && props.countries.map((country, k) => (
                                <option key={k} value={country.id}>
                                    {country.countryName.trim()}
                                </option>
                            ))}
                        </Select>
                    </FormControl>
                </Col>
            </Row>
        </>
    )
}

export default ManageUserDetails